// store.ts
import { defineStore } from "pinia";
import { state } from "./state";
import { getters } from "./getters";
import { actions } from "./actions";

export const useUtilsStore = defineStore("utilsStore", {
    state,
    getters,
    actions,
});
